<form class="form-popup" [formGroup]="formGroup">
  <mat-form-field appearance="fill">
      <mat-label>Group Code</mat-label>
      <input
          matInput
          name="Group Code"
          autocomplete="off"
          formControlName="inventoryGroupCode"
          maxlength="2"
          />
  </mat-form-field>
  <mat-form-field appearance="fill">
      <mat-label>Group Name</mat-label>
      <input
          matInput
          name="Group Name"
          autocomplete="off"
          formControlName="inventoryGroupName"
          />
  </mat-form-field>

  <!-- <mat-label>Active</mat-label> -->
  <mat-checkbox formControlName="active" >Active</mat-checkbox>
</form>
